import { Box, Divider, Flex, Text, VStack } from '@chakra-ui/react'
import { ScreenContext, useIsSuperAdmin } from '@hb/react'
import { ColorTagSettings, FloatingContainer, PageContainer } from '@hb/react-web'
import { colors } from '@hb/shared'
import { useContext } from 'react'
import { UserPracticeAccess } from '../../components/User/UserPracticeAccess'

// const SettingsContactView = () => (
//   <VStack mt={2} w="100%" bg="gray.50" borderRadius={4} border="1px solid #cdcdcd">
//     <Expandable
//       header={() => (
//         <Text fontFamily="Comfortaa" px={2} py={1}>
//           Contact Info
//         </Text>
//       )}>
//       <UserPanel noSignOut />
//     </Expandable>
//   </VStack>
// )
export const SettingsView = () => {
  const { contentHeight } = useContext(ScreenContext)
  const isSuperAdmin = useIsSuperAdmin()
  return (
    <PageContainer>
      <FloatingContainer maxW="600px" px={0} py={0} maxH={`${contentHeight - 60}px`}>
        <VStack divider={<Divider />} spacing={0} w="100%" align="flex-start">
          <Flex bg={colors.green.hex} color="white" w="100%" px={2}>
            <Text
              color="white"
              fontWeight={600}
              my={1}
              textShadow="1px 1px 3px #00000055"
              fontFamily="Comfortaa"
              fontSize="md">
              Settings{isSuperAdmin ? ' - HB Super Admin View' : ''}
            </Text>
          </Flex>
          <Box w="100%" maxH={`${contentHeight - 100}px`} overflowY="auto">
            <UserPracticeAccess />
            <Box
              px={4}
              py={4}
              borderTop="1px solid"
              borderColor="gray.200"
              _dark={{ borderColor: 'gray.700' }}>
              {/* §0.5.8 Color tag label customization */}
              <ColorTagSettings />
            </Box>
            {/* <SettingsContactView /> */}
          </Box>
        </VStack>
      </FloatingContainer>
    </PageContainer>
  )
}
